import type { ComponentChildren } from 'preact';
import { PageContainer } from './PageContainer';

/**
 * Opinionated wrapper around PageContainer that bakes in the platform's vertical-rhythm
 * presets. Use this for any single-column page body so the gutters + max-width + py spacing
 * stay consistent across surfaces.
 */
export interface PageBodyProps {
  rhythm?: 'page' | 'section' | 'tight' | 'none';
  children: ComponentChildren;
  /** Render as a different element. Defaults to `div`. */
  as?: 'div' | 'section' | 'main' | 'article' | 'header';
  class?: string;
}

const RHYTHM_CLASSES = {
  page:    'pt-8 pb-16',
  section: 'py-[clamp(48px,6vw,80px)]',
  tight:   'py-[clamp(28px,3.5vw,44px)]',
  none:    '',
};

export function PageBody({
  rhythm = 'page',
  children,
  as,
  class: extraClass,
}: PageBodyProps) {
  const Element = as ?? 'div';
  const innerClass = `${RHYTHM_CLASSES[rhythm]} ${extraClass ?? ''}`.trim();
  return (
    <Element>
      <PageContainer cap="wide" pad={false} class={innerClass}>
        {children}
      </PageContainer>
    </Element>
  );
}
